import { createSlice } from "@reduxjs/toolkit";
import { ObjectTypesState } from "../entities/interfaces/object-types-state.interface";
import getObjectTypesCases from "./cases/get-object-types.cases";

const initialState: ObjectTypesState = {
  objectTypes: [],
  isLoadingObjectTypes: false
};

const objectTypesSlice = createSlice({
  name: "object-types/v2",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getObjectTypesCases(builder);
  }
});

export default objectTypesSlice.reducer;
